import { useStore } from 'effector-react'
import * as React from 'react'
import {
  $transactionCount,
  $transactionCountByMonth,
  getTransactionCount,
  transactionsMounted,
} from './model'

export const useTransactionCount = () => {
  React.useEffect(() => {
    transactionsMounted()
  }, [])

  const transactionCount = useStore($transactionCount)
  const transactionCountByMonth = useStore($transactionCountByMonth)
  const loading = useStore(getTransactionCount.pending)

  return { transactionCount, transactionCountByMonth, loading }
}
